import { ChangeDetectionStrategy, Component, effect, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

import { ActivationFlowService } from '../activation/activation-flow.service';
import { TenantLifecycleService } from '../tenant-lifecycle.service';

/**
 * Card at the bottom of the admin sidebar. Trial: dismissible hint with the
 * remaining days. From the end of the trial on: persistent notice that the
 * workspace is read-only (or offline), always with the activation button,
 * which opens the activation modal for Company Administrators (or the
 * activation link the tenant API hands out, see ActivationFlowService). In the collapsed
 * sidebar only the icon is left, which starts the activation as well.
 */
@Component({
  selector: 'hypecast-admin-tenant-lifecycle-banner',
  templateUrl: './tenant-lifecycle-banner.component.html',
  styleUrl: './tenant-lifecycle-banner.component.scss',
  standalone: true,
  imports: [MatIconModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class TenantLifecycleBannerComponent {
  protected readonly lifecycle = inject(TenantLifecycleService);
  protected readonly activation = inject(ActivationFlowService);

  readonly collapsed = input(false);

  constructor() {
    // Ask for the link once the banner shows, so the label (activate or contact) is right from the start.
    effect(() => {
      if (this.lifecycle.bannerKind() !== 'none') {
        this.activation.prefetch();
      }
    });
  }

  protected activate(): void {
    this.activation.start();
  }
}
